import { useEffect, useState } from 'react';
import { useAppSelector } from '../app/hooks';
import { shockAbsorbersSelected, sortBy } from '../features/filter/filterSlice';
import { LoadingType } from '../features/filter/interfaces';
import { ShockAbsorberSolution } from '../interfaces';

interface Props {
  isLoading: LoadingType;
}

const useSortBy = ({ isLoading }: Props) => {
  const [shockAbsorbers, setShockAbsorbers] = useState<ShockAbsorberSolution[]>([]);
  const sorted = useAppSelector(sortBy);
  const shockAbsorbersResults = useAppSelector(shockAbsorbersSelected);

  useEffect(() => {
    if (
      isLoading === 'success' &&
      shockAbsorbersResults?.shockAbsorbers &&
      shockAbsorbersResults.shockAbsorbers.length > 0
    ) {
      const sortedShockAbsorbers =
        sorted === 'ASCENDING_PRICE'
          ? [...shockAbsorbersResults.shockAbsorbers].sort((a, b) => a.index - b.index)
          : [...shockAbsorbersResults.shockAbsorbers].sort((a, b) => b.index - a.index);

      setShockAbsorbers(sortedShockAbsorbers);
    } else {
      setShockAbsorbers([]);
    }
  }, [isLoading, shockAbsorbersResults, sorted]);
  return shockAbsorbers;
};

export default useSortBy;
